import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { EmptyDay } from '../planning/Day';

const _MS_PER_DAY = 1000 * 60 * 60 * 24;

class WinterDutyCalendarLine extends Component {

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const winterDutiesDifferent = JSON.stringify(this.props.winterDuties) !== JSON.stringify(nextProps.winterDuties);
        const daysDifferent = this.props.days[0] !== nextProps.days[0] ||
            this.props.days.length !== nextProps.days.length;
    const wasHighLighted = !!(String(this.props.person.id) === String(this.props.highLightPersonId));
    const isHighLighted = !!(String(nextProps.person.id) === String(nextProps.highLightPersonId));

        return winterDutiesDifferent || daysDifferent || (wasHighLighted !== isHighLighted);
    }

    render() {
        const props = this.props;
        const person = props.person;
    const highLightId = props.highLightPersonId != null ? String(props.highLightPersonId) : null;
        const granularity = props.granularity;
        const days = props.days;
        const dayWidth = props.dayWidth;
        const winterDuties = props.winterDuties;

        const hourComponents = winterDuties.map((duty, dutyIndex) => {
            const startTime = moment(duty.start).diff(props.startTime, 'hour') * dayWidth;
            const duration = moment(duty.end).diff(duty.start, 'hour');
            if (duration > 0) {
                return (
                    <div 
                        key={`hour-${props.person.id}-${duty.id || `${duty.start}-${duty.end}`}-${dutyIndex}`} 
                        className='winter-duty' 
                        style={{ left: `${startTime}%`, backgroundColor: duty.route?.hexColor || 'white', width: `${dayWidth * duration}%` }}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (props.onDutyClick) {
                                props.onDutyClick(duty, e);
                            }
                        }}
                    />
                );
            }
            return null;
        });

        const dayComponents = winterDuties.map((duty, i) => {
            const start = new Date(props.startTime);
            const calendarEnd = new Date(start.getTime() + (props.totalTime * _MS_PER_DAY));
            let dutyStart = new Date(duty.start);
            let dutyEnd = new Date(duty.end);

            // Check if duty intersects with the visible calendar period
            if (dutyEnd <= start || dutyStart >= calendarEnd) {
                return null; // Duty is completely outside visible range
            }

            // Clamp duty times to visible calendar bounds
            if (dutyStart < start) dutyStart = start;
            if (dutyEnd > calendarEnd) dutyEnd = calendarEnd;

            // Calculate precise positioning based on actual time within days
            const startTimeInDays = (dutyStart - start) / _MS_PER_DAY;
            const endTimeInDays = (dutyEnd - start) / _MS_PER_DAY;
            
            const leftPosition = startTimeInDays * dayWidth;
            const width = (endTimeInDays - startTimeInDays) * dayWidth;

            if (width > 0 && leftPosition >= 0 && leftPosition < 100) {
                return (
                    <div 
                        key={i} 
                        className='winter-duty day' 
                        style={{ left: `${leftPosition}%`, backgroundColor: duty.route?.hexColor || 'white', width: `${width}%` }}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (props.onDutyClick) {
                                props.onDutyClick(duty, e);
                            }
                        }}
                    />
                );
            }
            return null;
        });

        const grid = days.map((d, i) => {
            return <EmptyDay key={i} size={dayWidth} highlight={String(person.id) === highLightId} />
        });

        return (
            <div className="row" onClick={props.onClick || null}>
                <div className={`name${person.leader ? ' leader' : ''}`}>{person.name}</div>
                <div className='plans'>
                    {granularity === 'hour' ? hourComponents : dayComponents}
                </div>
                <div className='cell-grid'>
                    {grid}
                </div>
            </div>
        );
    }
}

WinterDutyCalendarLine.propTypes = {
    person: PropTypes.object.isRequired,
    winterDuties: PropTypes.array.isRequired,
    days: PropTypes.array.isRequired,
    dayWidth: PropTypes.number.isRequired,
    granularity: PropTypes.string.isRequired,
    highLightPersonId: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    onDutyClick: PropTypes.func,
    startTime: PropTypes.number.isRequired,
    totalTime: PropTypes.number.isRequired
};

export default WinterDutyCalendarLine;